import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import CardItem from "../components/cardItem"
class Malaysia extends Component {
	state={
		youshi:[
			{
				name:'留学社会环境好',
				content:'马来西亚是一个经济水平较高、社会发展稳定的国家，国内风光秀丽、环境优美、治安良好，而且马站的生活消费水平与欧美发达国家相比较低，很适合希望低价留学的留学生。',
			},
			{
				name:'留学英语环境好',
				content:'马来西亚是一个各民族、各国移民混居的国家，国内通行英语和马来语，也有很多人说中文和其他东南亚家语言，在这样的环境对留学生的语言学习有着很大的帮助，特别是马来西亚英语普及度高，学校采用全英文授课模式。',
			},
			{
				name:'留学文凭受认可',
				content:'马来西亚国内许多知名大学都属于世界一流的高等学府，另外部分学校所开办的双联课程也得到了世界普遍认可。中国承认马来西亚几十所学校，回国可以做学历认证，可以考公务员，落户北上广，享受留学生归国待遇。',
			},
			{
				name:'留学就业环境好',
				content:'马来西亚是一个经济非常发达的国家，甚至有人说马来西亚聚集了世界上最富有的华人，在马来西亚留学后留学生将有机会在这些华人开办的企业里就职。',
			},
			{
				name:'留学费用低廉',
				content:'马来西亚留学一年所需要花费的学费和生活费不会超过8万人民币，这仅相当于在欧美留学所需费用的四分之一左右。',
			},
			{
				name:'留学申请简单',
				content:'马来西亚学校申请条件的范围很广，留学生即使没有语言成然也可以提出电请，而马来西亚留学生签证的甲请不需要经济担保，通过率几乎为00%，可以说马来西亚是申请最为简单的留学国家。',
			},
			{
				name:'留学学制短',
				content:'马来西亚大部分学校保持英联邦国家的教育体制，本科三年，硕士一年到一年半。',
			},
			{
				name:'课程设计达到国际水准',
				content:'马来西亚学生除了可以获得学士学位以及硕士学位外，还可以获得国际认可的资格证书或专业文凭，这些都是作为就业的有力砝码。',
			}
		],
		zhuanye:[
			{
				title:'多媒体传播',
				content:'媒体传播领域专业介绍：本专业主要培养具有创意思维和现代设计理念，具有较强的造型能力和影像视听语言能力，掌握计算机图形图像设计工具。' +
					'就业前景：可在新闻媒体单位、电子音像出版社、影视制作部门、动画制作部门、网页制作部门、广告部门等现代文化产业从事相关创作和传播管理工作。<br><br>' +
					'推荐院校：林国荣大学、双威大学、泰莱大学、思特雅大学等。',
				img:require('../../static/images/malaysia03.jpg')
			},
			{
				title:'马来语专业',
				content:'掌握了地道的马来语，而且熟悉马来西亚企业文化，如果回国发展，这样的留学生肯定是大型跨国公司的首选。而且，这些企业的起点往往很高，收回留学投资也是很容易的事情。' +
					'有许多学成回国的学生被马来西亚公司聘请来开拓、管理在中国的分公司，给学生一个施展才华、体现自我价值的广阔空间。',
				img:require('../../static/images/malaysia04.jpg')
			},
			{
				title:'计算机IT类专业',
				content:'IT专业人才在全世界就业市场也是供不应求,并且计算机现在已经是生活中不可缺少的一部分，新型公司都会有IT部门，马来西亚的英文教学，更有利于学生的就业。\n' +
					'该专业毕业生的主要就业岗位有:软件工程师、硬件工程师、系统开发员、软件测试工程师、硬件测试工程师、系统测试工程师、数据分析师等。<br><br>\n' +
					'\n' +
					'推荐院校：亚太科技大学、世纪大学等。',
				img:require('../../static/images/malaysia05.jpg')
			},
			{
				title:'酒店与旅游管理',
				content:'马来西亚是一个以旅游业为主的国家，有全亚洲顶级的酒店管理专业。酒店管理专业本科都是会有带薪实习部分，让学生理论和实践相结合。' +
					'马来西亚是一个旅游国家，并且有全亚洲顶级的酒店管理专业，泰莱大学与法国图卢兹大学联办的学位课程，学生可以赴法国带薪实习，毕业后授予法国学位文凭。<br><br>推荐院校：泰莱大学、亚太科技大学等。',
				img:require('../../static/images/malaysia06.jpg')
			},
			{
				title:'会计专业',
				content:'会计专业在国外是比较紧缺的职业，会计专业ACCA会员资格在国际上得到广泛认可，得到欧盟立法以及许多国家公司法的承认。拥有ACCA会员资格，就可以在世界各地就业。ACCA会员可在工商企业财务部门、审计/会计师事务所、金融机构和财政、税务部门从事财务和财务管理工作。',
				img:require('../../static/images/malaysia07.jpg')
			}
		],
		jianjie:[
			{
				name:'马来西亚地理',
				content:'马来西亚面积33万平方公里。位于东南亚，地处太平洋和印度洋之间。全境被南中国海分成东马来西亚和西马来西亚两部分。西马来西亚为马来亚地区，位于马来半岛南部，北与泰国接壤，' +
					'西濒马六甲海峡，东临南中国海，东马来西亚为沙捞越地区和沙巴地区的合称，位于加里曼丹岛北部。海岸线总长约4192公里。属热带雨林气候。内地山区年均气温22℃—28℃，沿海平原为25℃-30℃。' +
					'人口273万。其中马来人及其他原住民占68.7%，华人占23.2%，印度人占6.9%。',
			},
			{
				name:'马来西亚经济',
				content:'马来西亚自然资源丰富。橡胶、棕油和胡椒的产量和出口量居世界前列。锡矿丰富，曾为世界产锡大国，但近年来产量明显减少。马来西亚盛产热带硬木。农业以经济作物为主，主要有橡胶、油棕、胡椒、可可和热带水果等。七十年代以来不断调整产业结构，' +
					'大力推行出口导向型经济，制造业、建筑业和服务业发展迅速。八十年代中期，因受世界经济衰退影响，经济出现困难。1987年以来经济持续高速发展，' +
					'年均国民经济增长率一直保持在8%以上，成为亚洲地区引人注目的新兴工业国之一。1991年，马政府提出跨世纪发展战略，旨在于2020年将马建成发达国家。',
			},
			{
				name:'马来西亚文化',
				content:'马来西亚是一个多民族、多宗教国家，马、华、印各族都有自己独特的文化。马来西亚是个以农立国的民族，因此维持着许多原始信仰，特别是各民族浓厚的宗教色彩。' +
					'其宗教融合了伊斯兰教、印度教、佛教，其中以印度教影响尤为深远。由于多民族的长期共同生活，形成一种多元的文化特色。作为曾经东西方文化的交融之地，马来西亚保持着纷杂的各地风格又形成了自己独具特色的一面，' +
					'其中以马来人和华人融合形成的"娘惹"文化为个中代表，渗透到了社会、风俗、饮食等各方面。',
			},
			{
				name:'马来西亚教育',
				content:'马来西亚高等教育以公立大学与私立大学并存。马来西亚私立高等院校众多，以英文为教学媒介语，兼招本国学生和外国留学生。私立院校大多采用引进英国、澳大利亚等国高等教育课程，开设学分转移和双联课程的教育模式。为了保障质量，马来西亚教育部成立了私立教以及国家学术鉴定局（LAN），' +
					'对私立教育机构的课程设置、学费以及师资水平进行监督和调控。少数外国高等院校在马来西亚设立有分校，比如英国诺丁汉大学，澳洲莫纳什大学，澳洲科廷大学。' +
					'文凭得到中国教育部认证以及国际认可。马来西亚高等教育学府所提供的学术资格包括证书、预科、大专、本科、硕士及博士学位资格。这些由政府及私人教育领域所提供的课程吸引了无数的海内外学子。',
			},
		],
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/malaysia01.jpg')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>马来西亚简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								马来西亚，简称大马（Malaysia），首都吉隆坡，是位于东南亚的一个国家。马来西亚由十三个州组成，共分为东西两大部分。马来西亚也是东南亚国家联盟的创始国之一。
							</div>
							<img className={'img'} src={require('../../static/images/malaysia02.jpg')} alt=""/>
						</div>
						<div className={'mingxiao'} style={{marginTop:'40px'}}>
							{
								this.state.jianjie.map((item,index)=>{
									return (
										<div className={'mingxiaoItem'} key={index}>
											<div className={'mingxiaoItemTitle line_wrap'}>
												<span className={'line_title'}>
													{item.name}
												</span>
											</div>
											<div className={'mingxiaoItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									)
								})
							}
						</div>
						<div className={'title'}>
							<span>马来西亚留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'textModule'}>
							{
								this.state.youshi.map((item,index)=>(
									<div className={'textModuleItem'} key={index}>
										<div className={'textModuleItemFlexWrap'}>
											<div className={'textModuleItemTitle'}>{item.name}</div>
											<div className={'textModuleItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									</div>
								))
							}
						</div>
						<div className={'title'}>
							<span>马来西亚留学热门专业</span>
							<span className={'line'}/>
						</div>
						<div className={'zhuanye'}>
							{
								this.state.zhuanye.map((item,index)=>(
									<CardItem item={item} key={index}/>
								))
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Malaysia